// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qtWq","col":"styles_col__3X3xj"};